import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation registry. Uses generator functions so you can easily extend them
 * later to read inline data-attributes (e.g., data-duration, data-delay).
 */
export const animationPresets = {
   'fade-up': (element) => ({
      from: { opacity: 0, visibility: 'visible', y: 60 },
      to: { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' },
   }),
   'fade-down': (element) => ({
      from: { opacity: 0, y: -40 },
      to: { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' },
   }),
   'fade-in': (element) => ({
      from: { opacity: 0 },
      to: { opacity: 1, duration: 0.8, ease: 'power2.out' },
   }),
   'scale-up': (element) => ({
      from: { opacity: 0, scale: 0.85 },
      to: { opacity: 1, scale: 1, duration: 0.8, ease: 'back.out(1.4)' },
   }),
};

/**
 * Attaches a ScrollTrigger animation to a single DOM element.
 * Isolated to make single-element debugging and unit testing straightforward.
 *
 * @param {HTMLElement} element - The DOM node to animate.
 */
export const animateElement = (element) => {
   const animationType = element.getAttribute('data-animate');
   const preset = animationPresets[animationType];

   if (!preset) {
      console.warn(
         `[ScrollTrigger] Unrecognized animation preset: "${animationType}" on`,
         element,
      );
      return;
   }

   const { from, to } = preset(element);

   gsap.fromTo(element, from, {
      ...to,
      scrollTrigger: {
         trigger: element,
         start: 'top 85%', // Triggers when top of element is 15% above the viewport bottom
         toggleActions: 'play none none none', // Plays once. Change to 'play none none reverse' to loop on scroll
         // markers: true, // Uncomment for visual layout debugging
      },
   });
};

/**
 * Scans the DOM and initializes animations for all targeted elements.
 *
 * @param {string} [selector='[data-animate]'] - CSS selector for target elements.
 */
export const initScrollAnimations = (selector = '[data-animate]') => {
   console.log('init scroll');
   const elements = document.querySelectorAll(selector);

   if (!elements.length) return;

   elements.forEach(animateElement);
};
